import { CssGlobalVariables } from '@/styles/types';

const getGlobalCssVariable = (property: CssGlobalVariables): string => {
  return getComputedStyle(document.body).getPropertyValue(property);
};

export default getGlobalCssVariable;
